import type { RolesFilters } from '../types';

export const roleKeys = {
  all: ['roles'] as const,
  lists: () => [...roleKeys.all, 'list'] as const,
  list: (filters: RolesFilters) => [...roleKeys.lists(), filters] as const,
  details: () => [...roleKeys.all, 'detail'] as const,
  detail: (id: string) => [...roleKeys.details(), id] as const,
  schemas: () => [...roleKeys.all, 'schemas'] as const,
  schemaFields: (model: string) => [...roleKeys.schemas(), 'fields', model] as const,
};
